import styled from 'styled-components';

export const BrandButtons = styled.div`
   margin-top: 24px;
   display: flex;
   justify-content: space-around;
   width: 100%;
`;
